import { render, staticRenderFns } from "./calligraphySeries.vue?vue&type=template&id=4d258bce&scoped=true"
import script from "./calligraphySeries.vue?vue&type=script&lang=ts"
export * from "./calligraphySeries.vue?vue&type=script&lang=ts"
import style0 from "./calligraphySeries.vue?vue&type=style&index=0&id=4d258bce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d258bce",
  null
  
)

export default component.exports